const $ = kendo.jQuery

function getGridColumns(typeNumCol) {
  const columns = [
    {
      field: 'DivisionId',
      title: 'DivisionId',
      hidden: true,
      headerAttributes: {
        style: 'text-align: center;',
      },
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'Division',
      title: 'Division',
      hidden: true,
      headerAttributes: {
        style: 'text-align: center;',
      },
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'PeriodStart',
      title: 'PeriodStart',
      hidden: true,
      headerAttributes: {
        style: 'text-align: center;',
      },
      attributes: {
        style: 'text-align: right;',
      },
      format: '{0:yyyy-MMM}',
    },
    {
      field: 'PeriodEnd',
      title: 'PeriodEnd',
      headerAttributes: {
        style: 'text-align: center;',
      },
      attributes: {
        style: 'text-align: right;',
      },
      hidden: true,
      format: '{0:yyyy-MMM}',
    },
    {
      field: 'Period',
      title: 'Period',
      width: '150px',
      hidden: false,
      headerAttributes: {
        style: 'text-align: center;',
      },
      attributes: {
        style: 'text-align: left;',
      },
    },
  ]

  typeNumCol.forEach(function(element) {
    const column = {
      field: element.field,
      title: element.typeNum,
      headerAttributes: {
        style: 'text-align: center;',
      },
      attributes: {
        style: 'text-align: right;',
      },
      width: '120px',
      format: '{0:N0}',
    }

    switch (column.field) {
      case 'Hedge':
        column.attributes['class'] = 'hedgeCDrillDown'
        break
      case 'Hedge_Ratio':
        column.format = '{0:P2}'
        break
      case 'Level':
        column.format = '{0:N4}'
        break
    }

    columns.push(column)
  })

  return [...columns, {}]
}

function renderGrid($container, options, renderLocation) {
  return new Promise(function(resolve) {
    const actionName = renderLocation == 'report' ? 'dataSource' : 'dataSourceComponent'
    const dataSourceUrl = `/api/heroux/ExposureReport/${actionName}`

    $.get(dataSourceUrl, options, function(response) {
      const {data, typeNumCols} = response

      const grid = $container
        .empty()
        .kendoGrid({
          editable: false,
          scrollable: false,
          dataSource: {
            data: data,
            schema: {
              model: {
                id: 'Id',
                fields: {
                  DivisionId: {
                    type: 'number',
                  },
                  Division: {
                    type: 'string',
                  },
                  PeriodStart: {
                    type: 'date',
                  },
                  PeriodEnd: {
                    type: 'date',
                  },
                },
              },
            },
          },
          dataBound: function(e) {
            if (renderLocation === 'dashboard') {
              const items = e.sender.dataSource.data().length
              if (items == 0) {
                e.sender.element.closest('.component').remove()
              }
              if (items > 25) {
                e.sender.element.closest('.component').prepend('<div class="page-break"/>')
              }
            }
            resolve(grid)
          },
          filterable: false,
          sortable: false,
          pageable: false,
          columns: getGridColumns(typeNumCols),
        })
        .data('kendoGrid')
    })
  })
}

export default {
  render: function($container, options, location = 'dashboard') {
    return renderGrid($container, options, location)
  },
}
